/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
$(document).ready(function () {
    const $swiperContainer = $(".included-accessories__carousel");
    if ($swiperContainer.length === 0) return; 

    const swiper = new Swiper($swiperContainer[0], { 
        slidesPerView: "auto",
        spaceBetween: 0,
        loop: false,
        navigation: {
            nextEl: ".included-accessories__control--next",
            prevEl: ".included-accessories__control--prev",
        },
    });

    $('.included-accessories__control--next').on('click', function (e) {
        e.preventDefault();
        swiper.slideTo(swiper.slides.length - 1);
    });

    $('.included-accessories__control--prev').on('click', function (e) {
        e.preventDefault();
        swiper.slideTo(0);
    });

});